import { render, staticRenderFns } from "./filterSideBar.vue?vue&type=template&id=b2972a92&scoped=true"
import script from "./filterSideBar.vue?vue&type=script&lang=js"
export * from "./filterSideBar.vue?vue&type=script&lang=js"
import style0 from "./filterSideBar.vue?vue&type=style&index=0&id=b2972a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2972a92",
  null
  
)

export default component.exports